import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import NavSideBarContext from 'contexts/NavSideBarContext';
import { CLOSED_NAV_WIDTH, OPENED_NAV_WIDTH } from 'navigation/styles';
import { V3_TOP_BAR_HEIGHT } from 'navigation/Authenticated/V3/Common/TopBarLayout';
import TopNavigator from './TopNavigator';
import PERMISSIONS from '../../../permissionDefinitions';
import PermissionGates from 'components/PermissionGates';
import { UIVersionContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const OPEN_NAV_OFFSET = OPENED_NAV_WIDTH;
const CLOSED_NAV_OFFSET = CLOSED_NAV_WIDTH;

const Wrapper = styled.div<{ isMainNavOpen: boolean; isV3: boolean }>`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: ${(props) =>
    props.isV3 ? `calc(100vh - ${V3_TOP_BAR_HEIGHT}px)` : '100vh'};
  width: calc(
    100vw -
      ${(props) =>
        props.isV3
          ? 0
          : props.isMainNavOpen
            ? OPEN_NAV_OFFSET
            : CLOSED_NAV_OFFSET}px
  );
`;

const AllSets = () => {
  const { isOpen: isMainNavOpen } = useContext(NavSideBarContext);
  const { isV3 } = useContext(UIVersionContext);

  return (
    <PermissionGates.Has
      requiredPermission={PERMISSIONS.DATA_MANAGEMENT.DATA_MANAGER_ACCESS}
    >
      <div
        id="data-manager-start"
        data-testid="data-manager-start"
        style={{ display: 'flex', flex: 1 }}
      >
        <Wrapper isMainNavOpen={isMainNavOpen} isV3={isV3}>
          <TopNavigator />
          <Outlet />
        </Wrapper>
      </div>
    </PermissionGates.Has>
  );
};

export default AllSets;
